import React from "react";
import { motion } from "framer-motion";
import BulletPoint from "./BulletPoint.jsx";

const AMD = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2, delay: 0.1 }}
      className="w-full"
    >
      {/* JOB TITLE & COMPANY */}
      <div className="flex text-white flex-wrap gap-1 font-medium text-xl font-titleFont flex-col sml:flex-row">
        <h3>Co-op Intern</h3>
        <a
          href="https://www.amd.com/en"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text-sm mt-1 font-medium text-textGreen flex">
            @AMD
          </span>
        </a>
      </div>
      {/* Working Dates */}
      <p className="pt-3 text-white">July 2025 - Present</p>
      {/* INTRODUCTION */}
      {/* <p className="mt-3 text-base font-light flex gap-2 text-textDark">
        <strong>
          Actively reviewed a comprehensive Node.js book covering beginner to
          advanced topics. Focused on enhancing the material by integrating
          practical suggestions and relevant real-world examples.
        </strong>
      </p> */}
      {/* Bullet Points */}
      <ul className="mt-4 flex flex-col gap-3 text-textDark">
        <BulletPoint
          headningText="AI-Driven Test Automation"
          contentText="Building an AI-driven test automation agent, reducing manual QA effort by 30% and improving edge-case defect detection by 10%."
        />
        <BulletPoint
          headningText="ROCm ML Framework Optimization"
          contentText="Optimizing and validating ROCm ML frameworks (hipDNN, Flash-Attention), delivering a 4% performance improvement across AMD GPU workloads."
        />
        <BulletPoint
          headningText="Kernel Validation Pipeline Scaling"
          contentText="Scaling kernel validation pipelines to ensure correctness and performance across ZEN and CDNA GPU architectures."
        />
        <BulletPoint
          headningText="Cross-Hardware Compatibility"
          contentText="Improving cross-hardware compatibility and expanding test coverage for ROCm math libraries and ML frameworks."
        />
      </ul>
    </motion.div>
  );
};

export default AMD;
